import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "../../styles/common/popup.scss";

const CreateFolderPopup = ({
  open,
  handleClose,
  onSave,
  title,
  contextKey,
  mode = "create",
  initialName = "",
  folderId,
}) => {
  const [name, setName] = useState("");

  const isSaveDisabled = !name.trim();

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    if (onSave) {
      onSave({ title, key: contextKey, name: trimmed, id: folderId });
    }
    handleClose();
  };

  useEffect(() => {
    if (open) {
      if (mode === "edit" && initialName) {
        setName(initialName);
      } else {
        setName("");
      }
    }
  }, [open, mode, initialName]);

  return createPortal(
    <div
      className={`common-popup-overlay ${open ? "" : "hidden"} high-z-index`}
      onClick={handleClose}
    >
      <div
        className="common-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header">
          <h2>{mode === "edit" ? "Edit Folder" : "Create Folder"}</h2>
          <button className="popup-close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="popup-content">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <div className="popup-form-group">
              <label htmlFor="folder-name">Folder Name</label>
              <input
                id="folder-name"
                type="text"
                className="popup-input"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="popup-actions">
              <button
                type="submit"
                className="popup-submit-button"
                disabled={isSaveDisabled}
              >
                {mode === "edit" ? "Save Changes" : "Create Folder"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CreateFolderPopup;
